import { useTotalSpotConversionMarginValue } from './useTotalSpotConversionMarginValue'
import { useMemo } from 'react'
import { BigNumber } from '@ethersproject/bignumber'
import { useRealTimeUnrealizedPnL } from './useRealTimeUnrealizedPnL'

export function useTotalEquityValue(): BigNumber {
  const conversionMargin = useTotalSpotConversionMarginValue()
  const totalUnrealizedPNL = useRealTimeUnrealizedPnL()
  return useMemo(() => {
    return conversionMargin.add(totalUnrealizedPNL)
  }, [conversionMargin, totalUnrealizedPNL])
}
